module.exports = __webpack_public_path__ + "img/in.17fa444c.svg";